import type { ChatMessageType } from "@/features/chat/shared/types";

export const MEDIA_MESSAGE_TYPES: ChatMessageType[] = [
  "push",
  "private_media",
  "live"
];

export const MAX_MESSAGE_LENGTH = 1500;

export const messageVariantsType: Record<string, "tip" | "live" | "default"> = {
  tip: "tip",
  live: "live"
};

export const messageLabelsType: Record<string, string | undefined> = {
  tip: "mym",
  push: "Push",
  private_media: "Private Media",
  live: "live"
};
